export default __webpack_public_path__ + "static/media/multiProduct.74363210.svg";